/******************************************************************************
 *
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Rahul Bagaria' <Rahul@wakencode.com>, September 2023
 *
 *****************************************************************************/

/**
 * This is a constant color file, all the color used in webapp are rest here
 */
export const COLOR = {
  ILLUMINATING_EMERALD: "#3a9f6b", // Primary color
  ANTI_FLASH_WHITE: "#f1f1f1", // Background color of content
  DAVYS_GREY: "#595959", // Pop up Header color
  GRAY: "#f0f0f0",
  PHILIPPINE_GRAY: "#8c8c8c", // Pop up body color
  ANTI_FLASH_WHITE_CARD: "#f0f3f5", // Card color
  RICH_BLACK: "rgba(0, 0, 0, 0.5)", // Used in pop up background
  WHITE: "#ffffff", //White
  DARK_GRAY: "#f4f4f4",
  CHINESE_BLACK: "#141414", // Card title color
  SLATE_GRAY: "#67748E", // Card details field color
  GUNMETAL: "#252F40", // Card details value color
  HONEYDEW: "#E7FAF1", //Send messages by user
  DARK_GREY: "rgba(89, 89, 89, 0.85)", // POP up input header color
  BLUE: "blue",
  GREEN: "Green",
  RED: "red",
  NEUTRAL: "#262626",
  BLACK: "#434343",
  LIGHT_SILVER: "#D9D9D9",
  LIGHT_BLACK: "rgba(0, 0, 0, 0.85)",
  DARK_BLACK: "#000000",
  SEASHELL: "#F1F1F1",
  DANGER: "#ff4d4f", // red color for danger state
  TEALISH_BLUE: "#8392ab",
};

// 'linear-gradient(107deg, #f7902d -41%, #ffb800 59%)'
export const LINEAR_GRADIENT_COLOR = {
  CONTACT_COLOR_CODE:
    "linear-gradient(to right, #f7902d, #ffb800)",
  MY_ACCOUNT_COLOR_CODE:
    "linear-gradient(to right, #59db13, #51b40c, #468f09, #396b08, #2a4a07)",
  PROPERTY_COLOR_CODE:
    "linear-gradient(to right, #13b9db, #059bb3, #047e8d, #06626a, #07474a)",
  INVOICE_COLOR_CODE:
    "linear-gradient(87deg, rgba(98,164,172,1) 0%, rgba(88,105,171,1) 100%)",
  WORK_ORDER_COLOR_CODE:
    "linear-gradient(to right, #db13b9, #aa1694, #7c1370, #520e4c, #2c072a)",
};
